import Vue from 'vue';
import jsonCSV from 'vue-json-csv';

Vue.component('DownloadCsv', jsonCSV);
